import React from 'react';
import './About.css';

const RefundPolicy = () => {
  return (
    <div className="about-page">
      <div className="page-hero" style={{
        background: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)'
      }}>
        <div className="container">
          <h1>Refund Policy</h1>
          <p>Understanding our refund process</p>
        </div>
      </div>

      <div className="container section">
        <div className="content-card">
          <p className="last-updated">Last Updated: October 15, 2025</p>

          <section className="policy-section">
            <h2>Refund Eligibility</h2>
            <p>Refunds are subject to our cancellation policy terms. The refundable amount depends on when you cancel before the departure date.</p>
          </section>

          <section className="policy-section">
            <h2>Refund Timeline</h2>
            <ul>
              <li>Refunds are processed within 7-10 business days after cancellation approval</li>
              <li>Amount will be credited to your original payment method</li>
              <li>Bank processing may take additional 3-5 business days</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2>Non-Refundable Items</h2>
            <p>Visa fees, travel insurance, and certain booking fees are non-refundable.</p>
          </section>

          <section className="policy-section">
            <h2>Travel Credit Option</h2>
            <p>Instead of a refund, you may opt for 110% travel credit valid for 12 months for future bookings.</p>
          </section>

          <section className="policy-section">
            <h2>Contact for Refunds</h2>
            <p>For refund inquiries, email syedabuzar626@gmail.com or call +91 9731395805</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
